import type { BillingPersonalizationResponse } from 'reactApp/api/billing/personalization/BillingPersonalizationAPICall.types';
import type { YearAndMonthProductIds } from 'reactApp/modules/products/products.types';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

interface BillingPersonalizationTariffLineData {
    default: string;
    list: YearAndMonthProductIds;
}

export interface BillingPersonalizationTariffsData {
    default: {
        period: 'year' | 'month';
        type: 'minimal' | 'base' | 'family' | 'business' | 'advanced';
    };
    minimal?: BillingPersonalizationTariffLineData;
    base?: BillingPersonalizationTariffLineData;
    family?: BillingPersonalizationTariffLineData;
    business?: BillingPersonalizationTariffLineData;
    advanced?: BillingPersonalizationTariffLineData;
}

export interface BillingPersonalizationState {
    isLoading: boolean;
    isLoaded: boolean;
    hasError: boolean;
    rawData: BillingPersonalizationResponse;
    web?: BillingPersonalizationTariffsData;
    iOS?: BillingPersonalizationTariffsData;
    android?: BillingPersonalizationTariffsData;
}

export const BillingPersonalizationTypeToTabName = {
    minimal: ETabsName.basic,
    base: ETabsName.advanced,
    advanced: ETabsName.advanced,
    family: ETabsName.family,
    business: ETabsName.for_work,
};

export type BillingPersonalizationTariffs = Partial<
    Record<ETabsName.advanced | ETabsName.basic | ETabsName.family | ETabsName.for_work, YearAndMonthProductIds>
>;
